import { RentService } from '../../epics/rent';
import { RentAllService } from '../../epics/rent/all';
import {
    addRentKey,
    deleteRentKey,
    editRentKey,
    getRentKey,
    getRentListKey,
    rentAllKey,
    rentAllListKey,
    updateRentKey,
} from './rentKeys';
import { createServiceThunk, createAddThunk } from '../thunkFactory';

export const addRent = createAddThunk(addRentKey, (v) => RentService.addRent(v));

export const getRentAllList = createServiceThunk(
    rentAllListKey,
    (p) => RentAllService.getRentAllList(p),
);

export const getRentAll = createServiceThunk(
    rentAllKey,
    (id) => RentAllService.getRentAll(id),
);

export const getRent = createServiceThunk(getRentKey, (id) => RentService.getRent(id));
export const getRentList = createServiceThunk(getRentListKey, (p) => RentService.getRentList(p));
export const deleteRent = createServiceThunk(deleteRentKey, (id) => RentService.deleteRent(id));
export const editRent = createServiceThunk(editRentKey, (u) => RentService.editRent(u));
export const updateRent = createServiceThunk(updateRentKey, (u) => RentService.updateRent(u));
